var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVideoOff = function SvgVideoOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27624 0.390625L0.390625 2.27624L4.78115 6.66677H4.00009C2.52733 6.66677 1.33343 7.86068 1.33343 9.33344V22.6668C1.33343 24.1395 2.52733 25.3334 4.00009 25.3334H20.0001C20.9363 25.3334 21.7598 24.851 22.2356 24.1212L29.724 31.6096L31.6096 29.724L2.27624 0.390625ZM20.0001 21.8857L7.44782 9.33344H4.00009V22.6668H20.0001V21.8857ZM22.6668 11.1761L30.6668 7.17606V24.4936L28.0001 21.8269V11.4908L22.6668 14.1575V17.3345L20.0001 14.6678V9.33343H14.6657L11.9991 6.66677H20.0001C21.4729 6.66677 22.6668 7.86067 22.6668 9.33343V11.1761Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VideoOff.7e503890.svg";
export { ForwardRef as ReactComponent };